import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Container } from './CareMenuImage.style';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE } from './CareMenuImageConst';

class CareMenuImage extends React.Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.canvas = React.createRef();
  }

  componentDidMount() {
    // 商品設定
    this.setItems();
    // リサイズイベント
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  shouldComponentUpdate(nextProps) {
    // メニュー用表示の場合は、組み合わせアイテムが変更されるまで、更新しない
    if (this.props.type) {
      if (this.props.category === CATEGORY_HAIRCARE) {
        if (
          nextProps.selectedInFillItem !== this.props.selectedInFillItem ||
          nextProps.selectedMaskItem !== this.props.selectedMaskItem
        ) {
          return true;
        }
      } else if (this.props.category === CATEGORY_SCALPCARE) {
        if (
          nextProps.selectedAdenovitalItem !== this.props.selectedAdenovitalItem ||
          nextProps.selectedAromaItem !== this.props.selectedAromaItem ||
          nextProps.selectedPreCleanseShampooItem !== this.props.selectedPreCleanseShampooItem
        ) {
          return true;
        }
      }
      return false;
    }
    return true;
  }

  componentDidUpdate() {
    // 商品設定
    this.setItems();
  }

  onResize = () => {
    if (!this.container || !this.container.current || !this.container.current.clientWidth || !this.canvas) return;
    const width = this.container.current.clientWidth || null;
    const height = Math.floor(width / 4 * 3);
    this.canvas.current.style.width = `${width}px`;
    this.canvas.current.style.height = `${height}px`;
  };

  // 商品設定
  setItems = () => {
    const { type, category } = this.props;
    if (type) {
      if (category === CATEGORY_HAIRCARE) {
        // ヘアケア商品設定（メニュー用）
        this.setHareCareItems();
      } else if (category === CATEGORY_SCALPCARE) {
        // スカルプケア商品設定（メニュー用）
        this.setScalpCareItems();
      }
    } else {
      if (category === CATEGORY_HAIRCARE) {
        // 選択済みヘアケア商品設定
        this.setSelectedHareCareItems();
      } else if (category === CATEGORY_SCALPCARE) {
        // 選択済みスカルプケア商品設定
        this.setSelectedScalpCareItems();
      }
    }
  };

  // キャンバスにイメージ貼り付け
  setImageToCanvas = (src, cb) => {
    if (!this.canvas || !this.canvas.current) return;
    if (!src) {
      if (cb) cb();
    }
    const context = this.canvas.current.getContext('2d') || null;
    if (!context) return;
    const image = new Image();
    image.onload = () => {
      context.drawImage(image, 0, 0, 960, 720);
      if (cb) cb();
    };
    image.src = src;
  };

  // ヘアケア商品設定（メニュー用）
  setHareCareItems = () => {
    const { type, selectedInFillItem, selectedMaskItem, hairCareList } = this.props;

    // ヘアケアアイテムイメージ
    const getHairCareImage = () => {
      for (let i = 0; i < hairCareList.length; i += 1) {
        if (hairCareList[i].slug === type) {
          if (
            hairCareList[i].resultMenuImage &&
            hairCareList[i].resultMenuImage.file &&
            hairCareList[i].resultMenuImage.file.url
          ) {
            return hairCareList[i].resultMenuImage.file.url;
          }
        }
      }
      return null;
    };

    // インフィルアイテムイメージ
    const getSelectedInFillItemImage = () => {
      if (!selectedInFillItem || !selectedInFillItem.resultMenuImage) return null;
      for (let i = 0; i < selectedInFillItem.resultMenuImage.length; i += 1) {
        if (selectedInFillItem.resultMenuImage[i].id && selectedInFillItem.resultMenuImage[i].id === type) {
          if (
            selectedInFillItem.resultMenuImage[i].image &&
            selectedInFillItem.resultMenuImage[i].image.file &&
            selectedInFillItem.resultMenuImage[i].image.file.url
          ) {
            return selectedInFillItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // マスクアイテムイメージ
    const getSelectedMaskItemImage = () => {
      if (!selectedMaskItem || !selectedMaskItem.resultMenuImage) return null;
      for (let i = 0; i < selectedMaskItem.resultMenuImage.length; i += 1) {
        if (selectedMaskItem.resultMenuImage[i].id && selectedMaskItem.resultMenuImage[i].id === type) {
          if (
            selectedMaskItem.resultMenuImage[i].image &&
            selectedMaskItem.resultMenuImage[i].image.file &&
            selectedMaskItem.resultMenuImage[i].image.file.url
          ) {
            return selectedMaskItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // キャンパスをクリア
    const context = this.canvas.current.getContext('2d');
    context.clearRect(0, 0, 960, 720);

    this.setImageToCanvas(getHairCareImage(), () => {
      this.setImageToCanvas(getSelectedInFillItemImage(), () => {
        this.setImageToCanvas(getSelectedMaskItemImage());
      });
    });
  };

  // スカルプケア商品設定（メニュー用）
  setScalpCareItems = () => {
    const {
      type,
      selectedAdenovitalItem,
      selectedAromaItem,
      selectedPreCleanseShampooItem,
      scalpCareList,
    } = this.props;

    // スカルプケアアイテムイメージ
    const getScalpCareImage = () => {
      for (let i = 0; i < scalpCareList.length; i += 1) {
        if (scalpCareList[i].slug === type) {
          if (
            scalpCareList[i].resultMenuImage &&
            scalpCareList[i].resultMenuImage.file &&
            scalpCareList[i].resultMenuImage.file.url
          ) {
            return scalpCareList[i].resultMenuImage.file.url;
          }
        }
      }
      return null;
    };

    // アデノバイタルアイテムイメージ
    const getSelectedAdenovitalItemImage = () => {
      if (!selectedAdenovitalItem || !selectedAdenovitalItem.resultMenuImage) return null;
      for (let i = 0; i < selectedAdenovitalItem.resultMenuImage.length; i += 1) {
        if (selectedAdenovitalItem.resultMenuImage[i].id && selectedAdenovitalItem.resultMenuImage[i].id === type) {
          if (
            selectedAdenovitalItem.resultMenuImage[i].image &&
            selectedAdenovitalItem.resultMenuImage[i].image.file &&
            selectedAdenovitalItem.resultMenuImage[i].image.file.url
          ) {
            return selectedAdenovitalItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // アロマアイテムイメージ
    const getSelectedAromaItemImage = () => {
      if (!selectedAromaItem || !selectedAromaItem.resultMenuImage) return null;
      for (let i = 0; i < selectedAromaItem.resultMenuImage.length; i += 1) {
        if (selectedAromaItem.resultMenuImage[i].id && selectedAromaItem.resultMenuImage[i].id === type) {
          if (
            selectedAromaItem.resultMenuImage[i].image &&
            selectedAromaItem.resultMenuImage[i].image.file &&
            selectedAromaItem.resultMenuImage[i].image.file.url
          ) {
            return selectedAromaItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // プレクレンズ&シャンプーアイテムイメージ
    const getSelectedPreCleanseShampooItemImage = () => {
      if (!selectedPreCleanseShampooItem || !selectedPreCleanseShampooItem.resultMenuImage) return null;
      for (let i = 0; i < selectedPreCleanseShampooItem.resultMenuImage.length; i += 1) {
        if (
          selectedPreCleanseShampooItem.resultMenuImage[i].id &&
          selectedPreCleanseShampooItem.resultMenuImage[i].id === type
        ) {
          if (
            selectedPreCleanseShampooItem.resultMenuImage[i].image &&
            selectedPreCleanseShampooItem.resultMenuImage[i].image.file &&
            selectedPreCleanseShampooItem.resultMenuImage[i].image.file.url
          ) {
            return selectedPreCleanseShampooItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // キャンパスをクリア
    const context = this.canvas.current.getContext('2d');
    context.clearRect(0, 0, 960, 720);

    this.setImageToCanvas(getScalpCareImage(), () => {
      this.setImageToCanvas(getSelectedAdenovitalItemImage(), () => {
        this.setImageToCanvas(getSelectedAromaItemImage(), () => {
          this.setImageToCanvas(getSelectedPreCleanseShampooItemImage());
        });
      });
    });
  };

  // 選択済みヘアケア商品設定
  setSelectedHareCareItems = () => {
    const { selectedHairCare, selectedInFillItem, selectedMaskItem } = this.props;

    // ヘアケアアイテムイメージ
    const getSelectedHairCareImage = () => {
      if (
        !selectedHairCare ||
        !selectedHairCare.resultMenuImage ||
        !selectedHairCare.resultMenuImage.file ||
        !selectedHairCare.resultMenuImage.file.url
      ) {
        return null;
      }
      return selectedHairCare.resultMenuImage.file.url;
    };

    // インフィルアイテムイメージ
    const getSelectedInFillItemImage = () => {
      if (!selectedHairCare || !selectedHairCare.slug) return null;
      if (!selectedInFillItem || !selectedInFillItem.resultMenuImage) return null;
      for (let i = 0; i < selectedInFillItem.resultMenuImage.length; i += 1) {
        if (
          selectedInFillItem.resultMenuImage[i].id &&
          selectedInFillItem.resultMenuImage[i].id === selectedHairCare.slug
        ) {
          if (
            selectedInFillItem.resultMenuImage[i].image &&
            selectedInFillItem.resultMenuImage[i].image.file &&
            selectedInFillItem.resultMenuImage[i].image.file.url
          ) {
            return selectedInFillItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // マスクアイテムイメージ
    const getSelectedMaskItemImage = () => {
      if (!selectedHairCare || !selectedHairCare.slug) return null;
      if (!selectedMaskItem || !selectedMaskItem.resultMenuImage) return null;
      for (let i = 0; i < selectedMaskItem.resultMenuImage.length; i += 1) {
        if (
          selectedMaskItem.resultMenuImage[i].id &&
          selectedMaskItem.resultMenuImage[i].id === selectedHairCare.slug
        ) {
          if (
            selectedMaskItem.resultMenuImage[i].image &&
            selectedMaskItem.resultMenuImage[i].image.file &&
            selectedMaskItem.resultMenuImage[i].image.file.url
          ) {
            return selectedMaskItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // キャンパスをクリア
    const context = this.canvas.current.getContext('2d');
    context.clearRect(0, 0, 960, 720);

    this.setImageToCanvas(getSelectedHairCareImage(), () => {
      this.setImageToCanvas(getSelectedInFillItemImage(), () => {
        this.setImageToCanvas(getSelectedMaskItemImage());
      });
    });
  };

  // 選択済みスカルプケア商品設定
  setSelectedScalpCareItems = () => {
    const { selectedScalpCare, selectedAdenovitalItem, selectedAromaItem, selectedPreCleanseShampooItem } = this.props;

    // スカルプケアアイテムイメージ
    const getSelectedScalpCareImage = () => {
      if (
        !selectedScalpCare ||
        !selectedScalpCare.resultMenuImage ||
        !selectedScalpCare.resultMenuImage.file ||
        !selectedScalpCare.resultMenuImage.file.url
      ) {
        return null;
      }
      return selectedScalpCare.resultMenuImage.file.url;
    };

    // アデノバイタルアイテムイメージ
    const getSelectedAdenovitalItemImage = () => {
      if (!selectedScalpCare || !selectedScalpCare.slug) return null;
      if (!selectedAdenovitalItem || !selectedAdenovitalItem.resultMenuImage) return null;
      for (let i = 0; i < selectedAdenovitalItem.resultMenuImage.length; i += 1) {
        if (
          selectedAdenovitalItem.resultMenuImage[i].id &&
          selectedAdenovitalItem.resultMenuImage[i].id === selectedScalpCare.slug
        ) {
          if (
            selectedAdenovitalItem.resultMenuImage[i].image &&
            selectedAdenovitalItem.resultMenuImage[i].image.file &&
            selectedAdenovitalItem.resultMenuImage[i].image.file.url
          ) {
            return selectedAdenovitalItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // アロマアイテムイメージ
    const getSelectedAromaItemImage = () => {
      if (!selectedScalpCare || !selectedScalpCare.slug) return null;
      if (!selectedAromaItem || !selectedAromaItem.resultMenuImage) return null;
      for (let i = 0; i < selectedAromaItem.resultMenuImage.length; i += 1) {
        if (
          selectedAromaItem.resultMenuImage[i].id &&
          selectedAromaItem.resultMenuImage[i].id === selectedScalpCare.slug
        ) {
          if (
            selectedAromaItem.resultMenuImage[i].image &&
            selectedAromaItem.resultMenuImage[i].image.file &&
            selectedAromaItem.resultMenuImage[i].image.file.url
          ) {
            return selectedAromaItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // プレクレンズ&シャンプーアイテムイメージ
    const getSelectedPreCleanseShampooItemImage = () => {
      if (!selectedScalpCare || !selectedScalpCare.slug) return null;
      if (!selectedPreCleanseShampooItem || !selectedPreCleanseShampooItem.resultMenuImage) return null;
      for (let i = 0; i < selectedPreCleanseShampooItem.resultMenuImage.length; i += 1) {
        if (
          selectedPreCleanseShampooItem.resultMenuImage[i].id &&
          selectedPreCleanseShampooItem.resultMenuImage[i].id === selectedScalpCare.slug
        ) {
          if (
            selectedPreCleanseShampooItem.resultMenuImage[i].image &&
            selectedPreCleanseShampooItem.resultMenuImage[i].image.file &&
            selectedPreCleanseShampooItem.resultMenuImage[i].image.file.url
          ) {
            return selectedPreCleanseShampooItem.resultMenuImage[i].image.file.url;
          }
        }
      }
      return null;
    };

    // キャンパスをクリア
    const context = this.canvas.current.getContext('2d');
    context.clearRect(0, 0, 960, 720);

    this.setImageToCanvas(getSelectedScalpCareImage(), () => {
      this.setImageToCanvas(getSelectedAdenovitalItemImage(), () => {
        this.setImageToCanvas(getSelectedAromaItemImage(), () => {
          this.setImageToCanvas(getSelectedPreCleanseShampooItemImage());
        });
      });
    });
  };

  render() {
    // console.log('@ CareMenuImage', this.props);
    return (
      <Container>
        <div ref={this.container}>
          <canvas ref={this.canvas} width="960" height="720" />
        </div>
      </Container>
    );
  }
}

CareMenuImage.defaultProps = {
  type: null,
  category: CATEGORY_HAIRCARE,
  selectedHairCare: {},
  selectedInFillItem: {},
  selectedMaskItem: {},
  selectedScalpCare: {},
  selectedAdenovitalItem: {},
  selectedAromaItem: {},
  selectedPreCleanseShampooItem: {},
  hairCareList: [],
  scalpCareList: [],
};
CareMenuImage.propTypes = {
  type: PropTypes.string,
  category: PropTypes.string,
  selectedHairCare: PropTypes.shape({}),
  selectedInFillItem: PropTypes.shape({}),
  selectedMaskItem: PropTypes.shape({}),
  selectedScalpCare: PropTypes.shape({}),
  selectedAdenovitalItem: PropTypes.shape({}),
  selectedAromaItem: PropTypes.shape({}),
  selectedPreCleanseShampooItem: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  hairCareList: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  scalpCareList: PropTypes.array,
};
const mapState = state => ({
  selectedHairCare: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedHairCare) {
      return state.diagnosisResult.selectedHairCare;
    }
    return null;
  })(),
  selectedInFillItem: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedInFillItem) {
      return state.diagnosisResult.selectedInFillItem;
    }
    return null;
  })(),
  selectedMaskItem: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedMaskItem) {
      return state.diagnosisResult.selectedMaskItem;
    }
    return null;
  })(),
  selectedScalpCare: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedScalpCare) {
      return state.diagnosisResult.selectedScalpCare;
    }
    return null;
  })(),
  selectedAdenovitalItem: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedAdenovitalItem) {
      return state.diagnosisResult.selectedAdenovitalItem;
    }
    return null;
  })(),
  selectedAromaItem: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedAromaItem) {
      return state.diagnosisResult.selectedAromaItem;
    }
    return null;
  })(),
  selectedPreCleanseShampooItem: (() => {
    if (state.diagnosisResult && state.diagnosisResult.selectedPreCleanseShampooItem) {
      return state.diagnosisResult.selectedPreCleanseShampooItem;
    }
    return null;
  })(),
  hairCareList: state.salonSolutionList.hairCare,
  scalpCareList: state.salonSolutionList.scalpCare,
});
export default connect(mapState)(CareMenuImage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/CareMenuImage/CareMenuImage.js